module.exports = __webpack_public_path__ + "assets/img/baja-carbon.8adce17b.png";